export const isAdvisoryRole = (roleName) => {
    let expression = /(ADVISORY)/i;
    return expression.test(roleName);
}